



































































import { Component, Prop, Vue } from "vue-property-decorator";
import { getAllUserGroups } from "@/services/users/userGroupService";
import { AclMember, AclMemberType } from "@/services/security/types";
import { getEditorUsers } from "@/services/users/usersService";
import { Getter } from "vuex-class";
import { addSolutionAccessFields } from "@/components/solutions/fields/solutionAccessFields";

const namespace: string = "authentication";
    @Component
export default class SolutionAccessModal extends Vue {
        @Prop() existingAcl!: AclMember[];
        userUserGroups = [] as AclMember[];
        selectedItems = [] as AclMember[];
        selectedUserUserGroups = [] as AclMember[];
        searchQuery = "";
        fields = addSolutionAccessFields;
        @Getter("getCurrentUser", { namespace }) getCurrentUser: any;
        // lifecycle hooks

        // computed
        get filteredData() {
            return this.userUserGroups && this.userUserGroups
                .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.username.toLowerCase().includes(this.searchQuery.toLowerCase())));
        }

        // methods
        fetchData() {
            this.userUserGroups = [];
            this.setSelectedItemsArray();
            getAllUserGroups()
                .then(response => {
                    this.userUserGroups = this.userUserGroups.concat(response.map(x => ({
                        id: x.id,
                        name: x.name,
                        type: AclMemberType.UserGroup,
                        username: ""
                    } as AclMember)));
                });
            getEditorUsers().then(response => {
                this.userUserGroups = this.userUserGroups.concat(response
                    .map(x => ({
                        id: x.id,
                        name: x.name,
                        username: x.email,
                        type: AclMemberType.User
                    } as AclMember)));
            });
        }

        select(items: AclMember[]) {
            this.selectedItems = items;
        }

        setSelectedItemsArray() {
            this.selectedUserUserGroups = [];
            this.selectedUserUserGroups =
                this.selectedUserUserGroups
                    .concat(this.existingAcl);
        }

        save() {
            this.selectedItems.forEach(sItem => {
                const item = this.userUserGroups.find(x => x.id === sItem.id);
                if (!item) { return; }

                const selectedItem = this.selectedUserUserGroups.find(x => x.id === item.id);

                if (!selectedItem) {
                    this.selectedUserUserGroups.push(item);
                }
            });
            this.$emit("accessUpdated", this.selectedUserUserGroups);
            this.$bvModal.hide("modal-boardAccess");
        }

        open() {
            this.fetchData();
            this.$bvModal.show("modal-boardAccess");
        }
}
